module.exports = __webpack_public_path__ + "static/media/firetender-logo.92fb7aa6.png";